__turbopack_context__.v({
  "button": "ShareButtons-module-scss-module__mtyeRa__button",
  "facebook": "ShareButtons-module-scss-module__mtyeRa__facebook",
  "icon": "ShareButtons-module-scss-module__mtyeRa__icon",
  "intent": "ShareButtons-module-scss-module__mtyeRa__intent",
  "pinterest": "ShareButtons-module-scss-module__mtyeRa__pinterest",
  "root": "ShareButtons-module-scss-module__mtyeRa__root",
  "sansEmail": "ShareButtons-module-scss-module__mtyeRa__sansEmail",
  "toast": "ShareButtons-module-scss-module__mtyeRa__toast",
});
